import { render, staticRenderFns } from "./CustomSection05.vue?vue&type=template&id=4a94110a&scoped=true&"
import script from "./CustomSection05.vue?vue&type=script&lang=js&"
export * from "./CustomSection05.vue?vue&type=script&lang=js&"
import style0 from "./CustomSection05.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CustomSection05.vue?vue&type=style&index=1&id=4a94110a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a94110a",
  null
  
)

component.options.__file = "CustomSection05.vue"
export default component.exports